import {
  MEETING_INTELLIGENCE_FEATURES
} from 'features/billing/modals/plan_selection_modal/config/addons'
import { ENTERPRISE } from 'features/billing/modals/plan_selection_modal/config/tiers'

const MAX_FEATURES_TO_SHOW = 3

const FEATURES = {
  'saml-sso': [
    'corporate_credentials',
    'session_duration',
    'password_strength'
  ],
  standard: [
    'unlimited_up_to_collective', // NOTE: not a real billing feature
    'workflows',
    'tracking', // NOTE: not a real billing feature
    'payments_integration'
  ],
  teams: [
    'round_robin_event_types',
    'managed_events',
    'salesforce_integration',
    'routing_forms',
  ],
  enterprise: [
    'unlock_features', // NOTE: not a real billing feature
    'saml_single_sign_on',
    'calendly_partner' // NOTE: not a real billing feature
  ]
}

const DEFAULT_MI_FEATURES = [
  'record_and_transcribe',
  'create_snippets',
  'retention',
]

// NOTE: same as this, but ensures we provide values for all the MI features
//   without hard-coding the list here.
//
// ```
// meeting_intelligence: DEFAULT_MI_FEATURES,
// meeting_intelligence_create_snippets: DEFAULT_MI_FEATURES,
// ...
// meeting_intelligence_vertical_frameworks: DEFAULT_MI_FEATURES
// ```
const MI_CUSTOM_FEATURES = Object.fromEntries(
  MEETING_INTELLIGENCE_FEATURES.map((feature) => [feature, DEFAULT_MI_FEATURES])
)

const CUSTOM_FEATURES = {
  // NOTE: not real billing features
  routing_forms_analytics: [
    'see_meetings_from_forms',
    'report_conversion_rates',
    'adjust_strategy_on_meetings'
  ],
  team_hubspot_routing: [
    'hubspot_integration',
    'user_groups',
    'admin_settings'
  ],
  'saml-sso-with-tier-upgrade': [
    'salesforce_integration',
    'admin_settings',
    'user_groups'
  ],
  gmail_contacts_integration: [
    'gmail_contacts_integration_feature_1',
    'gmail_contacts_integration_feature_2',
    'gmail_contacts_integration_feature_3'
  ],

  // NOTE: the following are actual billing feature keys
  ...MI_CUSTOM_FEATURES,
  crm_gmail_sync: [
    'prepare_one_place',
    'send_emails',
    'unlimited_types'
  ],
}

export const CRM_FEATURES = [
  'crm_gmail_sync',
  'crm_bulk_email',
  'crm_smart_compose',
  'crm_meeting_prep',
  'crm_bulk_email_trial'
]

export const CRM_TRIAL_FEATURES = [
  'crm_bulk_email_trial'
]

export const useFeatureList = (baseSku, featureKey) => {
  if (CUSTOM_FEATURES[featureKey]) {
    return CUSTOM_FEATURES[featureKey]
  }

  const filteredFeatures = baseSku === ENTERPRISE || !featureKey
    ? FEATURES[baseSku]
    : FEATURES[baseSku].filter((feature) => feature !== featureKey)

  if (!(filteredFeatures?.length > 0)) {
    throw new Error('useFeatureList: filteredFeatures is empty')
  }

  return filteredFeatures.slice(0, MAX_FEATURES_TO_SHOW)
}
